import {Injectable} from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, CanActivateChild, RouterStateSnapshot, UrlTree, Data} from '@angular/router';
import {AuthGuard} from './auth.guard';
import {HttpService} from '../service/http-service';
import {Observable} from 'rxjs';
import {Role} from '../_helpers/models/role';
import {Privileges} from '../_helpers/models/privileges';
import {RoleService} from '../service/role-service';

@Injectable({providedIn: 'root'})
export class RoleGuard implements CanActivate, CanActivateChild {

  constructor(public auth: AuthGuard, public router: Router,
              private httpService: HttpService) {
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (sessionStorage.getItem('token') === null || sessionStorage.getItem('token') === '') {
      return false;
    }
    const data: Data = route.data;
    return this.checkStatusByRoutingModule(data);
  }

  checkStatusByRoutingModule(data: Data): boolean {
    if (!HttpService.checkPrivilege(data.routingModule)) {
      this.httpService.showSnackBar('warning', 'You have not permission to access this URL !!!');
      return false;
    }
    return true;
  }

  checkStatusByRole(data: Data): boolean {
    for (let role of data.roles) {
      if (HttpService.getCurrentUserRole() === role) {
        return true;
      }
    }
    this.httpService.showSnackBar('warning', 'You have not permission to access this URL !!!');
    return false;
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(childRoute);
  }

}
